/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberStatus } from './MemberStatus';
import {
    MemberStatusFromJSON,
    MemberStatusFromJSONTyped,
    MemberStatusToJSON,
} from './MemberStatus';

/**
 * My Membership
 * @export
 * @interface MyMembership
 */
export interface MyMembership {
    /**
     * Member ID
     * @type {string}
     * @memberof MyMembership
     */
    id: string;
    /**
     * Account ID
     * @type {string}
     * @memberof MyMembership
     */
    accountId: string | null;
    /**
     * Given Name
     * @type {string}
     * @memberof MyMembership
     */
    givenName: string;
    /**
     * Family Name
     * @type {string}
     * @memberof MyMembership
     */
    familyName: string;
    /**
     * Street Address
     * @type {string}
     * @memberof MyMembership
     */
    streetAddress: string;
    /**
     * City
     * @type {string}
     * @memberof MyMembership
     */
    city: string;
    /**
     * State ID
     * @type {number}
     * @memberof MyMembership
     */
    stateId: number;
    /**
     * Zip Code
     * @type {string}
     * @memberof MyMembership
     */
    zipCode: string;
    /**
     * Date Joined
     * @type {Date}
     * @memberof MyMembership
     */
    dateJoined: Date;
    /**
     * 
     * @type {MemberStatus}
     * @memberof MyMembership
     */
    status: MemberStatus;
    /**
     * Descendant Of
     * @type {string}
     * @memberof MyMembership
     */
    descendantOf: string;
    /**
     * Is Active
     * @type {boolean}
     * @memberof MyMembership
     */
    isActive: boolean;
    /**
     * Sponsored By Member ID
     * @type {string}
     * @memberof MyMembership
     */
    sponsoredByMemberId: string | null;
    /**
     * Created Date
     * @type {Date}
     * @memberof MyMembership
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof MyMembership
     */
    updatedDate: Date;
}



/**
 * Check if a given object implements the MyMembership interface.
 */
export function instanceOfMyMembership(value: object): value is MyMembership {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('streetAddress' in value) || value['streetAddress'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('stateId' in value) || value['stateId'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('dateJoined' in value) || value['dateJoined'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('descendantOf' in value) || value['descendantOf'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('sponsoredByMemberId' in value) || value['sponsoredByMemberId'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function MyMembershipFromJSON(json: any): MyMembership {
    return MyMembershipFromJSONTyped(json, false);
}

export function MyMembershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyMembership {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'accountId': json['account_id'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'streetAddress': json['street_address'],
        'city': json['city'],
        'stateId': json['state_id'],
        'zipCode': json['zip_code'],
        'dateJoined': (new Date(json['date_joined'])),
        'status': MemberStatusFromJSON(json['status']),
        'descendantOf': json['descendant_of'],
        'isActive': json['is_active'],
        'sponsoredByMemberId': json['sponsored_by_member_id'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function MyMembershipToJSON(value?: MyMembership | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'account_id': value['accountId'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'street_address': value['streetAddress'],
        'city': value['city'],
        'state_id': value['stateId'],
        'zip_code': value['zipCode'],
        'date_joined': ((value['dateJoined']).toISOString()),
        'status': MemberStatusToJSON(value['status']),
        'descendant_of': value['descendantOf'],
        'is_active': value['isActive'],
        'sponsored_by_member_id': value['sponsoredByMemberId'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

